



















































import Vue from 'vue';
import { API } from '@/api';
import UnidadesAgregarDialog from '@/components/unidades/AgregarDialog.vue';
import UnidadesBorrarDialog from '@/components/unidades/BorrarDialog.vue';
import UnidadesEditarDialog from '@/components/unidades/EditarDialog.vue';
import AsociarUnidadPropietario from '@/components/propietarios/AsociarUnidadPropietario.vue';
import DisociarUnidadPropietario from '@/components/propietarios/DisociarUnidadPropietario.vue';

export default Vue.extend({

  components: { UnidadesAgregarDialog, UnidadesBorrarDialog, UnidadesEditarDialog,
    AsociarUnidadPropietario, DisociarUnidadPropietario },
  data: () => ({
    gridData: [],
    singleSelect: false,
    selected: [],
    unidad: null,
    headers: [
      { text: 'Unidad', value: 'name' },
      // { text: 'ID de unidad', value: 'id' },
      { text: 'Cuenta Contable', value: 'ctaContable' },
      /* { text: 'Nombre condominio', value: 'condominio.nombre' },
      { text: 'ID de condominio', value: 'condominio.id' },
      { text: 'Dirección', value: 'condominio.direccion' },
      { text: 'RFC', value: 'condominio.rfc' }, */
    ],
    total: 0,
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 20,
      sortBy: ['name'],
      sortDesc: [false],
    },
    isSelectedEmpty: true,
  }),
  methods: {
    async loadData() {
      try {
        this.selected = [];
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const datos = {admin, condo};
        console.debug('datos: %o', datos);
        const result = await this.$store.dispatch('getUnidadesList', {datos, options: this.options});
        console.debug('Data: %o', result.content);
        this.gridData = result.content;
        this.total = result.totalElements;
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async pageEventHandler(page) { // cargar mas registros
      console.debug('page: %o', event);
      this.loadData();
    },
    rowSelected(event) {
      if (this.selected[0] && this.selected[0].id === event.id) {
        this.selected = [];
      } else {
        this.selected = [event];
      }
    },
    reloadGrid(event) {
      this.loadData();
    },
  },
  watch: {
    selected() {
      // console.log('watch selected: ', this.selected);
      if (Array.isArray(this.selected) && this.selected.length === 0) {
        this.isSelectedEmpty = true;
        this.unidad = null;
      } else {
        this.isSelectedEmpty = false;
        this.unidad = this.selected[0];
      }
    },
  },
});
